import Hero from './components/Hero';
import WhatWeDo from './components/WhatWeDo';
import Problems from './components/Problems';
import Services from './components/Services';
import Results from './components/Results';
import CTA from './components/CTA';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <Hero />
      <WhatWeDo />
      <Problems />
      <Services />
      <Results />
      <CTA />
      <Footer />
    </div>
  );
}
